// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"46fba45b","453":"c908287f","578":"cb6c3c95","759":"2bd75d48","952":"4071e5e6"}[chunkId] + ".chunk.js";
};